import React, { Component } from 'react';
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Button, Grid, TableRow, TableCell } from '@material-ui/core';
import { SingleSwitch } from '../../../../commonModules/MUI/RadioAndCheckbox.jsx';

class FormQuote extends Component {
    state = { }
    
    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.keys(SHOPS).map( ID => { 
                const shop = SHOPS[ID]     
                let selected = !!shop.shop_disabled || this.props.sale.shop_id === ID
                // if(this.props.sale.shop_id === ID) {  // already selected   
                //     selected = true 
                // } 
                list.push (       
                    {value:ID, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        return (
            <Grid className="card-text">
                <h4 className="card-title">Nouvelle Cotation</h4>

                <Box p={2}>
                    <Grid container spacing={2} >
                        {this.props.fromResa && this.props.sale.shop_id &&
                            <Grid item xs={12}>
                                <InputText
                                    value={this.props.SHOPS[this.props.sale.shop_id].name || ""}
                                    error={this.props.errors.shop_id}
                                    label="Magasin"
                                /> 
                            </Grid>
                        }
                        <Grid item xs={12}>
                        </Grid>
                        {!this.props.fromResa &&
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    options={[
                                        {value:"mjb", label:"Plateforme MyJouleBox"},
                                        {value:"other", label:"Autre plateforme"},
                                    ]}
                                    value={this.props.sale.cli_typeDisplay}
                                    onChange={(option) => this.props.handleSelect(option, "cli_type")}
                                    error={this.props.errors.cli_type}
                                    label="Type Client"
                                    // isOptionDisabled={(option) => option.disabled === true}
                                /> 
                            </Grid>
                        }
                        
                        {!this.props.fromResa &&
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    options={shops}
                                    value={this.props.sale.shop_idDisplay || {value:"", label:""}}
                                    onChange={(option) => this.props.handleSelect(option,"shop_id")}
                                    error={this.props.errors.shop_id}
                                    label="Magasin"
                                /> 
                            </Grid>
                        }
                        
                        <Grid item xs={12}>
                            <FormLayout 
                                {...this.props} 
                                title={"Produits"}
                                createAddForm={this.props.createAddFormP}
                                onClick={this.props.handleAddProd}
                                onClickForCSVUpload={this.props.handleAddProdByCSV}
                                colSpan={4}
                            /> 
                        
                        </Grid>
                            <Grid item xs={12}>
                                <InputText 
                                    onChange={this.props.handleChange} 
                                    value={this.props.sale.comments} 
                                    name="comments" 
                                    title="Modalités de paiement ou autres informations" 
                                    error={this.props.errors.comments} 
                                    required
                                    multiline
                                    rows={3} 
                                />
                            </Grid>
                        <Grid item sm={6}></Grid>
                        <Grid item sm={6} xs={12} className="text-left">
                            <InputText 
                                haserror={(this.props.errors.discount ? "has-error" : "")} 
                                change={this.props.handleChange} 
                                value={this.props.sale.discount} 
                                name="discount" 
                                title="Reduction" 
                                error={this.props.errors.discount} 
                                disabled 
                            />
                        
                            <InputText 
                                haserror={(this.props.errors.total ? "has-error" : "")} 
                                change={this.props.handleChange} 
                                value={this.props.sale.total} 
                                name="total" 
                                title="Total" 
                                error={this.props.errors.total} 
                                disabled 
                            />
                        </Grid>
                    </Grid>
                        
                    <Box p={2} >
                        <div className="pull-right">
                            <Button color="secondary" variant="contained" onClick={this.props.validate}>Valider</Button>
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>                    
                    </Box>
                </Box>
            </Grid>
        );
    }
}

export default FormQuote;